import React from "react";
import { Component } from "react";
import { Button } from "react-bootstrap";
import Icons from "../../../../../icon";
import { inventoryCircuitActions } from "../../../../../../store/external/reports-reducer/inventory/circuit.reducer";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ConfirmationNotificationModal }  from "../../../../modal/confirmation-modal.component";
import moment from 'moment';
import { CONFIRMATION_VALUE } from "../../../../../../utils/constant.utils";
import { trueFalseToBoolean } from "../../../../../../utils/helpers.utils";
class InvoiceHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            commentID: undefined,
            expanded: false,
            showModal: false
        }
        this.handleDelete = this.handleDelete.bind(this);
        this.handleDeleteCircuitComments = this.handleDeleteCircuitComments.bind(this);
    }
    componentDidMount() {
        const { getInventoryCircuitComments, inventoryCircuitFormA } = this.props;
        getInventoryCircuitComments(inventoryCircuitFormA.circuitID)
        .then(()=>{ this.setState({isLoading:false})
        });
    }
    handleViewMore() {
        this.setState({ expanded: true })
    }
    handleViewLess() {
        this.setState({ expanded: false })
    }
    handleConfirmationModal = (okCancel) => {
        if(CONFIRMATION_VALUE.Ok === okCancel) {
            this.handleDeleteCircuitComments()
            
        }
        this.setState(prevState => ({ showModal: !prevState.showModal,  commentID: undefined}));
    }
    handleDelete(commentID) {
        this.setState({
            commentID : commentID,
            showModal: true,
            modalMessage: "Are you sure you want to delete?"
        });
        
    }
    handleDeleteCircuitComments = async () => {
        this.setState({isLoading:true});
        const { inventoryCircuitFormA, deleteInventoryCircuitComments, getInventoryCircuitComments } = this.props;
        await deleteInventoryCircuitComments(this.state.commentID, inventoryCircuitFormA.circuitID);
        await getInventoryCircuitComments(inventoryCircuitFormA.circuitID) .then(()=>{
            this.setState({isLoading:false})
        });
        this.setState({show : false})
    }
    loading = () => {
        return (
            <div className="loading-request-details-holder width-100 text-align-center">
                <div className="lds-default">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        );
    }
    
    render() {
        if(this.state.isLoading) {
            return this.loading()
        }
        return (
            <div className="history-wrapper">
                <div className="data-container">
                    {(this.props.dataInfo ?? this.props.dataInfo.length > 0 ) ?
                        this.props.dataInfo.slice(0, this.state.expanded ? (this.props.dataInfo ?? this.props.dataInfo.length ) : 5).map((data, index) =>
                            <div key={index} className="history-container">
                                <div className="file-with-icon-container">
                                
                                    {
                                        data["State"]  &&
                                        JSON.parse(data["FileName"]) && JSON.parse(data["FileName"]).map((file, i) => (
                                            <div key={i} className="file-item">
                                                <Icons
                                                    customClassName="icon-file-clip"
                                                    name="paper-clip-solid"
                                                    size="14px"
                                                    containerClass="icon-paper-clip-file-container"
                                                />
                                                {data["State"]} 
                                                {file}
                                            </div>
                                        ))}
                                        {
                                        data["State"]  && 
                                    <Icons
                                        customClassName="icon-trash"
                                        name="trash-can"
                                        size="14px"
                                        containerClass="icon-trash-container"
                                        onClick={() => this.handleDelete(data["CommentID"])}
                                    />
                                        }
                                </div>
                                <div className="vertical-blue-line">
                                </div>
                                <div className="history-detail-container">
                                    <div className="history-detail-header">
                                        <span className="history-name-label"> {data["FirstName"]} {data["LastName"]} </span> <p> posted on</p> <span className="history-date-label">{moment.utc(data["DateCreated"]).format("MMMM DD, yyyy")}</span> at <span className="history-date-time">{moment(data["CurrentTime"]).format('hh:mm A')} </span>
                                    </div>
                                    <p>
                                       {data["Comment"]}
                                    </p>
                                </div>
                            </div>
                        )
                        :
                        <div className="no-message-container">
                            <h1>{this.props.noMessage}</h1>
                        </div>
                    }
                </div>
                <ConfirmationNotificationModal show={this.state.showModal} customClass="comment-notification-modal" handleModal={this.handleConfirmationModal} message={this.state.modalMessage} />
                {(this.props.dataInfo ?? this.props.dataInfo.length > 5) && !this.state.expanded && (
                    <Button className="view-more-button" onClick={this.handleViewMore.bind(this)}>View More</Button>
                )}
                {this.state.expanded && (
                    <Button className="view-more-button" onClick={this.handleViewLess.bind(this)}>View Less</Button>
                )}
    
            </div>
        )
    }
}
export default connect(
    state => {
        const { inventoryCircuit } = state;
        const { inventoryCircuitFormA } = state.form;

        return {
            inventoryCircuit,
            inventoryCircuitFormA
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryCircuitActions),
        dispatch
    )
)(InvoiceHistory);
